import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormErrorsService {

  constructor() { }

  public errorMensaje(form: FormGroup, controlName: string){
    let errorName: string = Object.keys(form.controls[controlName].errors)[0];
    let error: any = Object.values(form.controls[controlName].errors)[0];

    const mensajes = {
      required: () => `required`,
      pattern: () => `pattern`,
      minlength: () => `minlength`,
      maxlength: () => `maxlength`,
    };

    return mensajes[errorName](error);
  }

  public mostrarError(form: FormGroup, controlName: string){
    let controlForm = form.controls[controlName];
    if(!controlForm.errors) return false;
    return controlForm.hasError(Object.keys(controlForm.errors)[0]);
  }

  
}
